// extracted by mini-css-extract-plugin
module.exports = {"layout":"_3R0RnAgEO3b8YxsTEFoD2y","nav":"_3YQXTjKpfwAhR1hUCWnQI6","logo":"_8AyNqr1vn_lQttT2b-_wr","brand":"_2hmRTBvDFVzcwT3TO6C-Ib"};